export interface HeaderNavRect {
  right?: number;
  left?: number;
  width?: number;
}
